import React from "react";

const Footer = () => {
  return (
    <div
      style={{
        backgroundColor: "#f4f4f4",
        padding: "20px",
        textAlign: "center",
        fontSize: "0.9em",
        color: "#555",
      }}
    >
      <p>© 2025 Your Inventory System Name. All Rights Reserved.</p>
      <p>
        <a
          href="/privacy-policy"
          style={{ color: "#555", textDecoration: "none", marginRight: "15px" }}
        >
          Privacy Policy
        </a>
        <a
          href="/terms-of-service"
          style={{ color: "#555", textDecoration: "none", marginRight: "15px" }}
        >
          Terms of Service
        </a>
        <a href="/contact" style={{ color: "#555", textDecoration: "none" }}>
          Contact Us
        </a>
      </p>
      {/* <p>
        Need help? Visit our{" "}
        <a href="/support" style={{ color: "#007bff", textDecoration: "none" }}>
          Support Center
        </a>
        .
      </p> */}
    </div>
  );
};

export default Footer;
